module.exports = __webpack_public_path__ + "img/feature-3.ae38229e.jpg";